import axios from 'axios'
import services from '@/config/services.js'
import authHeader from '../auth/auth-header';
import Cookies from 'js-cookie';
import service from '@/config/services'
import FileManager from '@/services/levante-file-manager/index.js'
import { property } from 'underscore';

export default class PraticheService {
  constructor(eventBus) {
    this.eventBus = eventBus
    this.baseUrl = `${services.levante_api.url}`
    this.filemanager = new FileManager()
    axios.interceptors.request.use(
      (req) => {
        req.headers["Authorization"] = authHeader()
        req.headers["token"] = Cookies.get('ask_access_token')
        req.headers["Params"] = Cookies.get('google_access_token') || Cookies.get('ask_access_token')
        // this.eventBus.emit('data-loading');
        return req
      }
    )
  }
  async getPostByUrl(url, fd) {
    let item = [];
    try {
      const res = await axios.post(url, fd)
      item = res.data
      if (item.status === false) {
        // Redirect to /login if status is false
        window.location.href = '/login';
        return;
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async getGetByUrl(url, params = {}) {
    let items = [];
    try {
      const res = await axios.get(url, { params })
      items = res.data
      if (items.status === false) {
        // Redirect to /login if status is false
        window.location.href = '/login';
        return;
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
    }
    return {
      items
    }
  }

  async checkToken(token) {
    const url = `${this.baseUrl}/logged`
    const res = await axios.get(url)
    var test = res.data
    const out = [];
    out["status"] = test;
    return out
  }
  async getDetails(type_search, id) {
    const url = `${this.baseUrl}/get-${type_search}-${id}`
    return await this.getGetByUrl(url)
  }
  async getSessioni(id) {
    const url = `${this.baseUrl}/get-sessioni-${id}`
    return await this.getGetByUrl(url)
  }
  async getKitDetails(id) {
    const url = `${this.baseUrl}/getkitdet/${id}`
    return await this.getGetByUrl(url)
  }
  async getVenditeDaConsegnare() {
    const url = `${this.baseUrl}/get-vendite-daconsegnare`
    return await this.getGetByUrl(url)
  }
  async getComuni() {
    const url = `${this.baseUrl}/get-comuni`
    return await this.getGetByUrl(url)
  }
  async getTrainerTipologia(id) {
    const url = `${this.baseUrl}/getTrainerTipologia/${id}`
    return await this.getGetByUrl(url)
  }
  async getDaPagare(type_search, id) {
    const url = `${this.baseUrl}/get-dapagare-${type_search}-${id}`
    return await this.getGetByUrl(url)
  }
  async getPagamenti(type_search, id) {
    const url = `${this.baseUrl}/getPagamenti-${type_search}-${id}`
    return await this.getGetByUrl(url)
  }
  async getVendita(type_search, id) {
    const url = `${this.baseUrl}/getVendita-${type_search}-${id}`
    return await this.getGetByUrl(url)
  }
  async getAtletiUtente(id) {
    const url = `${this.baseUrl}/getAtletiUtente/${id}`
    return await this.getGetByUrl(url)
  }
  async getAtletiByUtente(id) {
    return await this.getAtletiUtente(id)
  }
  async updateCoachDays(id, assignments) {
    const url = `${this.baseUrl}/corso/${id}/update-coach-days`
    const fd = new FormData()
    fd.append('assignments', JSON.stringify(assignments))
    return await this.getPostByUrl(url, fd)
  }
  async updateCoachTimeSlots(id, timeSlots) {
    const url = `${this.baseUrl}/corso/${id}/update-coach-time-slots`
    const fd = new FormData()
    fd.append('timeSlots', JSON.stringify(timeSlots))
    return await this.getPostByUrl(url, fd)
  }
  async getProdotti() {
    const url = `${this.baseUrl}/get-prodotti`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getKit() {
    const url = `${this.baseUrl}/get-kit`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getTessere() {
    const url = `${this.baseUrl}/get-tessere`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getTypesOfFiles() {
    const url = `${this.baseUrl}/getTypesOfFiles`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getProdottiToBuy() {
    const url = `${this.baseUrl}/getProdottiToBuy`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getKitToBuy() {
    const url = `${this.baseUrl}/getKitToBuy`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getProdottiDisponibili() {
    const url = `${this.baseUrl}/get-prodotti-disponibili`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getTypesProdotti() {
    const url = `${this.baseUrl}/get-types-prodotti`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getAtleti() {
    const url = `${this.baseUrl}/get-atleti`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getCorsoSessioni() {
    const url = `${this.baseUrl}/corso-sessioni`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getCorsoSessioniNextWeek() {
    const url = `${this.baseUrl}/corso-sessioni-next-week`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getAllModulistica() {
    const url = `${this.baseUrl}/modulistica/get-all`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getAllTransactionsNoUsed(params = {}) {
    const url = `${this.baseUrl}/transactions/get-all-notused`
    let item = await this.getGetByUrl(url, params)
    return item
  }
  async getAllTransactionsUsed(params = {}) {
    const url = `${this.baseUrl}/transactions/get-all-used`
    let item = await this.getGetByUrl(url, params)
    return item
  }
  async getCorsi() {
    const url = `${this.baseUrl}/get-corsi`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getCorsiAtleta(id) {
    const url = `${this.baseUrl}/get-dettaglio-corso-for-atleta-${id}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getStatiche() {
    const url = `${this.baseUrl}/get-statiche`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getIntro() {
    const url = `${this.baseUrl}/get-intro`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getNewsInApp() {
    const url = `${this.baseUrl}/get-newsInApp`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getSponsor() {
    const url = `${this.baseUrl}/getSponsor`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getRichiesteProva() {
    const url = `${this.baseUrl}/get-richiesteProva`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getRichiesteUtenti() {
    const url = `${this.baseUrl}/getNoteUtenti`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getRichiestePulmino() {
    const url = `${this.baseUrl}/get-richiestePulmino`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getAllRichiestePulmino(anno) {
    const url = `${this.baseUrl}/getAllRichiestePulmino/${anno}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getCorsoOrariAtleta(id) {
    const url = `${this.baseUrl}/get-corso-orari-atleta/${id}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getSlotsPerTipologia(giorno, tipologia) {
    const url = `${this.baseUrl}/getSlotsPerTipologia/${giorno}/${tipologia}`
    let item = await this.getGetByUrl(url)
    return item
  }

  // ── Appuntamenti responsabili corsi ─────────────────────────────────────
  async getResponsabiliCorsi() {
    const url = `${this.baseUrl}/appuntamenti/responsabili`
    return await this.getGetByUrl(url)
  }
  async getStatisticheProspetto() {
    const url = `${this.baseUrl}/appuntamenti/statistiche-prospetto`
    return await this.getGetByUrl(url)
  }
  async getAppuntamentiDisponibilitaGiorno(id_personale, giorno) {
    const url = `${this.baseUrl}/appuntamenti/disponibilita/${id_personale}/${giorno}`
    return await this.getGetByUrl(url)
  }
  async getAppuntamentiDisponibilitaMese(id_personale, mese) {
    const url = `${this.baseUrl}/appuntamenti/disponibilita/${id_personale}?mese=${mese}`
    return await this.getGetByUrl(url)
  }
  async addAppuntamentoDisponibilita(fd) {
    const url = `${this.baseUrl}/appuntamenti/disponibilita/add`
    return await this.getPostByUrl(url, fd)
  }
  async deleteAppuntamentoDisponibilita(fd) {
    const url = `${this.baseUrl}/appuntamenti/disponibilita/delete`
    return await this.getPostByUrl(url, fd)
  }
  async prenotaAppuntamentoAdmin(fd) {
    const url = `${this.baseUrl}/appuntamenti/prenota-admin`
    return await this.getPostByUrl(url, fd)
  }
  async cancellaPrenotazioneAppuntamentoAdmin(fd) {
    const url = `${this.baseUrl}/appuntamenti/cancella-prenotazione-admin`
    return await this.getPostByUrl(url, fd)
  }
  async getPulmini(anno) {
    const url = `${this.baseUrl}/getPulmini/${anno}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getPreOrdini() {
    const url = `${this.baseUrl}/get-preOrdini`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getRichiesteProvaCorso(id) {
    const url = `${this.baseUrl}/get-richiesteProvaCorso/${id}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getToPay(mese, anno) {
    const url = `${this.baseUrl}/get-ToPay-${mese}-${anno}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getPayments(mese, anno) {
    const url = `${this.baseUrl}/get-Pagamenti-${mese}-${anno}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getPaymentsDay(giorno) {
    const url = `${this.baseUrl}/get-Pagamenti/${giorno}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getPaymentStatsByCategory(mese, anno) {
    const url = `${this.baseUrl}/payment-stats-category-${mese}-${anno}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getPaymentStatsByProduct(mese, anno) {
    const url = `${this.baseUrl}/payment-stats-products-${mese}-${anno}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getStaff() {
    const url = `${this.baseUrl}/get-staffs`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getVendite() {
    const url = `${this.baseUrl}/get-vendite`
    let item = await this.getGetByUrl(url)
    return item
  }
  async userMonthly() {
    const url = `${this.baseUrl}/userMonthly`
    return await this.getGetByUrl(url)
  }
  async salesMonthly() {
    const url = `${this.baseUrl}/salesMonthly`
    return await this.getGetByUrl(url)
  }
  async attendancesMonthly() {
    const url = `${this.baseUrl}/attendancesMonthly`
    return await this.getGetByUrl(url)
  }
  async paymentsMonthly() {
    const url = `${this.baseUrl}/paymentsMonthly`
    return await this.getGetByUrl(url)
  }
  async paymentsDaily() {
    const url = `${this.baseUrl}/paymentsDaily`
    return await this.getGetByUrl(url)
  }
  async paymentsMonthlyPerPay() {
    const url = `${this.baseUrl}/paymentsMonthlyPerPay`
    return await this.getGetByUrl(url)
  }
  async getTypePay() {
    const url = `${this.baseUrl}/get-type-pay`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getTypePayCassa() {
    const url = `${this.baseUrl}/get-type-pay-cassa`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getDocumentiApp(id) {
    const url = `${this.baseUrl}/get-documenti-app/${id}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getPrenotazioni(id) {
    const url = `${this.baseUrl}/getPrenotazioniVisite/${id}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getAttivita() {
    const url = `${this.baseUrl}/get-attivita`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getProdottiGruppo(id) {
    const url = `${this.baseUrl}/get-prodotti-gruppo/${id}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getDocumentiGruppo(id) {
    const url = `${this.baseUrl}/get-documenti-gruppo/${id}`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getPrenotazioniGruppo() {
    const url = `${this.baseUrl}/get-prenotazioni-gruppo`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getCitta() {
    const url = `${this.baseUrl}/get-citta`
    let item = await this.getGetByUrl(url)
    return item
  }
  async getNotifiche(id) {
    const url = `${this.baseUrl}/getNotifiche/${id}`
    let item = await this.getGetByUrl(url)
    return item

  }
  async getUtenti() {
    const url = `${this.baseUrl}/get-utenti`
    return await this.getGetByUrl(url)
  }
  async getCampi() {
    const url = `${this.baseUrl}/get-campi`
    return await this.getGetByUrl(url)
  }
  async getCampiForTypeCorso(id) {
    const url = `${this.baseUrl}/get-campi-for-type-corso-${id}`
    return await this.getGetByUrl(url)
  }
  async getNotificheAtleta(id) {
    const url = `${this.baseUrl}/getNotificheAtleta/${id}`
    return await this.getGetByUrl(url)
  }
  async check_can_reserve(idcorso, id) {
    const url = `${this.baseUrl}/check_can_reserve/${idcorso}/${id}`
    return await this.getGetByUrl(url)
  }
  async getPresenzeStaff(id) {
    const url = `${this.baseUrl}/get-presenze-staff/${id}`
    return await this.getGetByUrl(url)
  }
  async getPresenzeStaffPerCorso(id, mese) {
    const url = `${this.baseUrl}/get-presenze-staff-per-corso/${id}/${mese}`
    return await this.getGetByUrl(url)
  }
  async getMonthlyPresence(id) {
    const url = `${this.baseUrl}/getMonthlyPresence/${id}`
    return await this.getGetByUrl(url)
  }
  async getMonthlyPresenceOLD(id) {
    const url = `${this.baseUrl}/getMonthlyPresenceOLD/${id}`
    return await this.getGetByUrl(url)
  }
  async getDailyPresence(id, id_corso, mese) {
    const url = `${this.baseUrl}/getDailyPresence/${id}/${id_corso || 'all'}/${mese}`
    return await this.getGetByUrl(url)
  }
  async getTornei() {
    const url = `${this.baseUrl}/getTornei`
    return await this.getGetByUrl(url)
  }
  async getIscrittiSezione(id, idcorso) {
    const url = `${this.baseUrl}/get-iscritti-sezione/${id}/${idcorso}`
    return await this.getGetByUrl(url)
  }
  async getStaffCorso(id, idcorso) {
    const url = `${this.baseUrl}/get-staff-corso-sezione/${id}/${idcorso}`
    return await this.getGetByUrl(url)
  }
  async getAthleteTournaments(id) {
    const url = `${this.baseUrl}/get-athlete-tournaments/${id}`
    return await this.getGetByUrl(url)
  }
  async getTypePersonale() {
    const url = `${this.baseUrl}/get-type-personale`
    return await this.getGetByUrl(url)
  }
  async getTypeVisita() {
    const url = `${this.baseUrl}/get-type-visita`
    return await this.getGetByUrl(url)
  }
  async getTypeCorso() {
    const url = `${this.baseUrl}/get-type-corso`
    return await this.getGetByUrl(url)
  }
  async getCorsiAttivi() {
    const url = `${this.baseUrl}/get-active-corsi`
    return await this.getGetByUrl(url)
  }
  async getAtletiForCorso(id) {
    const url = `${this.baseUrl}/get-atleti-for-corso-${id}`
    return await this.getGetByUrl(url)
  }
  async getPagamentiCorsoMese(mese) {
    const url = `${this.baseUrl}/getPagamentiCorsoMese/${mese}`
    return await this.getGetByUrl(url)
  }
  async getMonthlySummary(month) {
    const url = `${this.baseUrl}/reports/monthly-summary`
    return await this.getGetByUrl(url, { month })
  }

  async getMonthlySummaryDetails(type, id, month, isAcconto = 0) {
    const url = `${this.baseUrl}/reports/monthly-summary/details`
    return await this.getGetByUrl(url, { type, id, month, is_acconto: isAcconto })
  }

  async getControlloCorsiPagamenti(params = {}) {
    let url = `${this.baseUrl}/reports/controllo-corsi`
    const searchParams = new URLSearchParams()
    if (params.target_month) {
      searchParams.append('target_month', params.target_month)
    }
    const queryString = searchParams.toString()
    if (queryString) {
      url += `?${queryString}`
    }
    return await this.getGetByUrl(url)
  }

  async updateAccontoPayment(id, productId, notes, idIscrizione, idTorneoExt, idProdottoLinked, idKitLinked) {
    const url = `${this.baseUrl}/reports/update-acconto-payment`
    return await this.getPostByUrl(url, { 
      id, 
      product_id: productId, 
      notes,
      id_iscrizione: idIscrizione,
      id_torneo_ext: idTorneoExt,
      id_prodotto: idProdottoLinked,
      id_kit: idKitLinked
    })
  }

  async getAthleteAssociations(idAtleta) {
    const url = `${this.baseUrl}/reports/athlete-associations/${idAtleta}`
    return await this.getGetByUrl(url)
  }

  async getAccontoProducts() {
    const url = `${this.baseUrl}/getProdottiToBuy`
    const res = await this.getGetByUrl(url)
    if (res && res.items) {
      return res.items.filter(p => p.isAcconto == 1);
    }
    return [];
  }

  async getDocs(id) {
    const url = `${this.baseUrl}/get-docs/${id}`
    return await this.getGetByUrl(url)
  }
  async getAtletiInCorso(id) {
    const url = `${this.baseUrl}/get-atleti-in-corso-${id}`
    return await this.getGetByUrl(url)
  }

  async getOrphanedPayments() {
    const url = `${this.baseUrl}/admin/orphaned-payments`
    return await this.getGetByUrl(url)
  }

  async getAthleteUnpaidRequests(idAtleta) {
    const url = `${this.baseUrl}/admin/atleta/${idAtleta}/unpaid-requests`
    return await this.getGetByUrl(url)
  }

  async resolveOrphanedPayment(idPagamentoDet, newIdRichiesta) {
    const url = `${this.baseUrl}/admin/resolve-orphaned-payment`
    return await this.getPostByUrl(url, {
      id_pagamento_det: idPagamentoDet,
      new_id_richiesta: newIdRichiesta
    })
  }

  async deleteEntirePayment(idPagamento) {
    const url = `${this.baseUrl}/admin/delete-payment`
    return await this.getPostByUrl(url, {
      id_pagamento: idPagamento
    })
  }

  async quickResolveWithAcconto(idPagamentoDet) {
    const url = `${this.baseUrl}/admin/quick-resolve-acconto`
    return await this.getPostByUrl(url, {
      id_pagamento_det: idPagamentoDet
    })
  }

  async saveTorneoExt(fd) {
    const url = `${this.baseUrl}/save-torneo-ext`
    return await this.getPostByUrl(url, fd)
  }

  async getTypeCorsoPersonale() {
    const url = `${this.baseUrl}/get-type-corso-personale`
    return await this.getGetByUrl(url)
  }
  async getPagamentiApp() {
    const url = `${this.baseUrl}/get-pagamenti-app`
    return await this.getGetByUrl(url)
  }
  async getFigc(id) {
    const url = `${this.baseUrl}/get-figc/${id}`
    return await this.getGetByUrl(url)
  }
  async getPagamentiAppVerified() {
    const url = `${this.baseUrl}/get-pagamenti-verificati-app`
    return await this.getGetByUrl(url)
  }
  async getPagamentiAppAll() {
    const url = `${this.baseUrl}/get-pagamenti-app-all`
    return await this.getGetByUrl(url)
  }
  async getMorosi() {
    const url = `${this.baseUrl}/get-morosi/10`
    return await this.getGetByUrl(url)
  }
  async getAccessiApp() {
    const url = `${this.baseUrl}/get-accessi-app`
    return await this.getGetByUrl(url)
  }
  async getDetailTorneo(id) {
    const url = `${this.baseUrl}/getDetailTorneo/${id}`
    return await this.getGetByUrl(url)
  }
  async getCorsiPersonale(id) {
    const url = `${this.baseUrl}/get-corsi-personale-${id}`
    return await this.getGetByUrl(url)
  }
  async getPersonale(type) {
    const url = `${this.baseUrl}/get-personale-${type}`
    return await this.getGetByUrl(url)
  }
  async getAllPersonale() {
    const url = `${this.baseUrl}/get-all-personale`
    return await this.getGetByUrl(url)
  }
  async getPersonaleForCorso(cod_type) {
    const url = `${this.baseUrl}/get-personaleForCorso-${cod_type}`
    return await this.getGetByUrl(url)
  }
  async getSizes() {
    const url = `${this.baseUrl}/get-sizes`
    return await this.getGetByUrl(url)
  }
  async getTypesAtleta() {
    const url = `${this.baseUrl}/get-types-atleta`
    return await this.getGetByUrl(url)
  }
  async getGalleryCorso(id) {
    const url = `${this.baseUrl}/get-gallery-corso/${id}`
    return await this.getGetByUrl(url)
  }
  async getGalleryProdotto(id) {
    const url = `${this.baseUrl}/get-gallery-prodotto/${id}`
    return await this.getGetByUrl(url)
  }
  async getPaymentSummary(id) {
    const url = `${this.baseUrl}/corso/${id}/payment-summary`
    return await this.getGetByUrl(url)
  }
  async getPaymentDetails(id, month) {
    const url = `${this.baseUrl}/corso/${id}/payment-details/${month}`
    return await this.getGetByUrl(url)
  }
  async getEmails(id) {
    const url = `${this.baseUrl}/get-emails/${id}`
    return await this.getGetByUrl(url)
  }
  async getAthleteAttendanceSummary() {
    const url = `${this.baseUrl}/attendance/athletes-summary`
    return await this.getGetByUrl(url)
  }
  async getStaffAttendanceSummary() {
    const url = `${this.baseUrl}/attendance/staff-summary`
    return await this.getGetByUrl(url)
  }
  async getAthleteAttendanceDetails(data) {
    const url = `${this.baseUrl}/attendance/athlete-details`
    return await this.getPostByUrl(url, data)
  }
  async getStaffAttendanceDetails(data) {
    const url = `${this.baseUrl}/attendance/staff-details`
    return await this.getPostByUrl(url, data)
  }
  async getActiveCorsi(data) {
    const url = `${this.baseUrl}/get-active-corsi`
    return await this.getGetByUrl(url, data)
  }

  async getAllItemsForMindTableClienti(opts = {}) {
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/clienti/search`

    try {
      let res = await this.http.post(url, { filters: opts })
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }


  async tryToLogin(fd) {
    let item = [];
    const url = `${this.baseUrl}/tryToLogin`
    try {
      const res = await axios.post(url, fd)
      item = res.data
      if (item.status) {
        const thisdom = service.main_domain.cookie.replace(/^\.+/, '');
        // console.log(thisdom)
        Cookies.set('ask_access_token', item.token, { domain: thisdom, expires: 1 }); // Imposta il cookie per scadere tra 7 giorni
        axios.defaults.headers.common['Authorization'] = `Bearer ${item.token}`;
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async postRequest(endpoint, fd) {
    const url = `${this.baseUrl}/${endpoint}`;
    let item = [];
    try {
      const res = await axios.post(url, fd);
      item = res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-loaded');
      // eslint-disable-next-line no-unsafe-finally
      return { item };
    }
  }

  async importTransaction(fd) {
    return this.postRequest.call(this, 'transactions/import', fd);
  }
  async previewTransaction(fd) {
    return this.postRequest.call(this, 'transactions/preview-import', fd);
  }
  async getLastDate() {
    const url = `${this.baseUrl}/transactions/get-last-date`
    return await this.getGetByUrl(url)
  }
  async delTransaction(fd) {
    return this.postRequest.call(this, 'transactions/delete', fd);

  }

  async delToPayAtleta(fd) {
    let item = [];
    const url = `${this.baseUrl}/del-topay-atleta`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async delCorsoAtleta(fd) {
    let item = [];
    const url = `${this.baseUrl}/remove-corso-atleta`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async sendRataToAdd(fd) {
    let item = [];
    const url = `${this.baseUrl}/save-rata-to-buy`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async delDoc(fd) {
    let item = [];
    const url = `${this.baseUrl}/remove-doc`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async updateDoc(id, fd) {
    let item = [];
    const url = `${this.baseUrl}/set-approved-documento/${id}`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async sendProductToBuy(fd) {
    let item = [];
    const url = `${this.baseUrl}/save-product-to-buy`
    try {
      const res = await axios.post(url, fd, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async sendKitToBuy(fd) {
    let item = [];
    const url = `${this.baseUrl}/save-kit-to-buy`
    try {
      const res = await axios.post(url, fd, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async sendReset(fd) {
    let item = [];
    const url = `${this.baseUrl}/resetPwd`
    try {
      const res = await axios.post(url, fd, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async saveScadenza(fd) {
    let item = [];
    const url = `${this.baseUrl}/saveScadenza`
    try {
      const res = await axios.post(url, fd, {

      })
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async sendResetTrainer(fd) {
    let item = [];
    const url = `${this.baseUrl}/resetPwdTrainer`
    try {
      const res = await axios.post(url, fd, {

      })
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async sendAssociaToUser(fd) {
    let item = [];
    const url = `${this.baseUrl}/associaToUser`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async getTypeProdottiAll() {
    const url = `${this.baseUrl}/type-prodotto`
    return await this.getGetByUrl(url)
  }

  async sendAppPresentation(fd) {
    let item = [];
    const url = `${this.baseUrl}/send-app-presentation`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async saveTypeProdotto(data, id = null) {
    let url = `${this.baseUrl}/type-prodotto`
    let method = 'post'
    if (id) {
      url += `/${id}`
      method = 'put'
    }

    let item = []
    try {
      const res = await axios[method](url, data)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return { item }
  }

  async deleteTypeProdotto(id) {
    const url = `${this.baseUrl}/type-prodotto/${id}`
    let item = []
    try {
      const res = await axios.delete(url)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return { item }
  }

  async reorderTypeProdotti(items) {
    const url = `${this.baseUrl}/type-prodotto/reorder`
    let item = []
    try {
      const res = await axios.post(url, { items })
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return { item }
  }

  async getTypeProdottoProducts(id) {
    const url = `${this.baseUrl}/type-prodotto/${id}/products`
    return await this.getGetByUrl(url)
  }

  async reorderTypeProdottoProducts(items) {
    const url = `${this.baseUrl}/type-prodotto/products/reorder`
    let item = []
    try {
      const res = await axios.post(url, { items })
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return { item }
  }

  async sendDoc(fd) {
    let item = [];
    const url = `${this.baseUrl}/save-doc`
    try {
      const res = await axios.post(url, fd, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async sendModulistica(fd) {
    let item = [];
    const url = `${this.baseUrl}/modulistica/save`
    try {
      const res = await axios.post(url, fd, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }


  async saveKit(fd) {
    let item = [];
    const url = `${this.baseUrl}/save-kit`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async sendDataNewUser(fd) {
    let item = [];
    const url = `${this.baseUrl}/creazione-utente`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async sendNotificaGruppoCorso(fd) {
    let item = [];
    const url = `${this.baseUrl}/sendNotificaGruppoCorso`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async sendMessaggeGruppoPrenotati(fd) {
    let item = [];
    const url = `${this.baseUrl}/sendNotificaGruppoCorsoPrenotati`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async sendMessaggeGruppoSelezionati(fd) {
    let item = [];
    const url = `${this.baseUrl}/sendMessaggeGruppoSelezionati`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async sendRichiestaProva(fd) {
    let item = [];
    const url = `${this.baseUrl}/sendRichiestaProva`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async sendRichiestaPulmino(fd) {
    let item = [];
    const url = `${this.baseUrl}/savePulmino`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async savePresenze(fd) {
    let item = [];
    const url = `${this.baseUrl}/save-presenze`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async saveAssenzeStaff(fd) {
    let item = [];
    const url = `${this.baseUrl}/save-assenze-staff`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async sendDataNewAtleta(fd) {
    let item = [];
    const url = `${this.baseUrl}/creazione-atleta`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async addDayInCourse(fd) {
    let item = [];
    const url = `${this.baseUrl}/addDayInCourse`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async saveOrarioSessione(fd) {
    let item = [];
    const url = `${this.baseUrl}/save-orario-sessione`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async saveDataSessione(fd) {
    let item = [];
    const url = `${this.baseUrl}/save-data-sessione`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async saveCampoSessione(fd) {
    let item = [];
    const url = `${this.baseUrl}/save-campo-sessione`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async saveAtleta(fd, id) {
    const url = `${this.baseUrl}/saveAtleta/${id}`
    return await this.getPostByUrl(url, fd)
  }
  async addDaPagareTornei(fd) {
    const url = `${this.baseUrl}/aggiungiDaPagareTorneo`
    return await this.postData(url, fd)
  }

  async addAtletaManualeTorneo(fd) {
    const url = `${this.baseUrl}/addAtletaManualeTorneo`
    return await this.postData(url, fd)
  }
  async saveNumeroMaglia(fd) {
    const url = `${this.baseUrl}/app/v1/saveNumeroMaglia`
    return await this.getPostByUrl(url, fd)
  }
  async deleteSlot(fd) {
    const url = `${this.baseUrl}/delSlot`
    return await this.getPostByUrl(url, fd)
  }

  async uploadGalleryImageProdotto(fd) {
    const url = `${this.baseUrl}/upload-gallery-image-prodotto`
    return await this.getPostByUrl(url, fd)
  }
  async deleteGalleryImageProdotto(id) {
    const url = `${this.baseUrl}/delete-gallery-image-prodotto/${id}`
    return await this.getPostByUrl(url, {})
  }

  async resetPwd(fd) {
    const url = `${this.baseUrl}/resetPwd`
    return await this.getPostByUrl(url, fd)
  }

  async addSlot(fd) {
    const url = `${this.baseUrl}/addSlot`
    return await this.getPostByUrl(url, fd)
  }
  async sendTorneo(fd) {
    const url = `${this.baseUrl}/sendTorneo`
    return await this.getPostByUrl(url, fd)
  }
  async deleteTorneo(fd) {
    const url = `${this.baseUrl}/deleteTorneo`
    return await this.getPostByUrl(url, fd)
  }
  async saveConsegnaMerce(fd) {
    const url = `${this.baseUrl}/saveConsegnaMerce`
    return await this.getPostByUrl(url, fd)
  }
  async sendNewDataUtente(fd) {
    const url = `${this.baseUrl}/modifica-utente`
    return await this.getPostByUrl(url, fd)
  }
  async sendNewDataAtleta(fd) {
    const url = `${this.baseUrl}/modifica-atleta`
    return await this.getPostByUrl(url, fd)
  }
  async updateRateIscrizione(fd) {
    const url = `${this.baseUrl}/aggiorna-rate-iscrizione`
    return await this.getPostByUrl(url, fd)
  }
  async resetRateIscrizione(fd) {
    const url = `${this.baseUrl}/reset-rate-iscrizione`
    return await this.getPostByUrl(url, fd)
  }
  async saveNotifica(fd) {
    const url = `${this.baseUrl}/sendNotifica`
    return await this.getPostByUrl(url, fd)
  }
  async updateVenditaConsegnata(fd) {
    const url = `${this.baseUrl}/updatePreOrdineConsegna`
    return await this.getPostByUrl(url, fd)
  }
  async uploadGalleryImage(fd) {
    const url = `${this.baseUrl}/upload-gallery-image`
    return await this.getPostByUrl(url, fd)
  }
  async deleteGalleryImage(id) {
    const url = `${this.baseUrl}/delete-gallery-image/${id}`
    return await this.getPostByUrl(url)
  }
  async delMovimento(fd) {
    const url = `${this.baseUrl}/delMovimento`
    return await this.getPostByUrl(url, fd)
  }
  async viewRicevuta(fd) {
    const url = `${this.baseUrl}/view-ricevuta`
    return await this.getPostByUrl(url, fd)
  }
  async sendRicevuta(id, fd) {
    const url = `${this.baseUrl}/sendRicevuta/${id}`
    return await this.getPostByUrl(url, fd)
  }
  async approvaAttivita(id, fd) {
    const url = `${this.baseUrl}/set-approved-attivita/${id}`
    return await this.getPostByUrl(url, fd)
  }
  async salvaModificaImporto(id, fd) {
    const url = `${this.baseUrl}/change-richiesta-pagamento/${id}`
    return await this.getPostByUrl(url, fd)
  }
  async delCorsoData(fd) {
    const url = `${this.baseUrl}/delCorsoData`
    return await this.getPostByUrl(url, fd)
  }
  async cancellaRicevuta(id, fd) {
    const url = `${this.baseUrl}/cancellaRicevuta/${id}`
    return await this.getPostByUrl(url, fd)
  }
  async aggiornaRicevuta(id, fd) {
    const url = `${this.baseUrl}/aggiornaRicevuta/${id}`
    return await this.getPostByUrl(url, fd)
  }
  async saveCorsoData(fd) {
    const url = `${this.baseUrl}/update-corso`
    return await this.getPostByUrl(url, fd)
  }
  async saveProdottoData(fd) {
    const url = `${this.baseUrl}/update-prodotto`
    return await this.getPostByUrl(url, fd)
  }
  async cancellaPrenotazione(fd) {
    const url = `${this.baseUrl}/cancellaSlot`
    return await this.getPostByUrl(url, fd)
  }
  async prenotaSlot(fd) {
    const url = `${this.baseUrl}/prenotaSlot`
    return await this.getPostByUrl(url, fd)
  }
  async modificaSlot(fd) {
    const url = `${this.baseUrl}/modificaSlot`
    return await this.getPostByUrl(url, fd)
  }
  async saveKitData(fd) {
    const url = `${this.baseUrl}/update-kit`
    return await this.getPostByUrl(url, fd)
  }
  async sendReminderCorso(fd) {
    const url = `${this.baseUrl}/sendReminderCorso`
    return await this.getPostByUrl(url, fd)
  }
  async sendVendita(fd) {
    const url = `${this.baseUrl}/creazione-vendita`
    return await this.getPostByUrl(url, fd)
  }
  async sendPagamento(fd) {
    const url = `${this.baseUrl}/creazione-pagamento`
    return await this.getPostByUrl(url, fd)
  }
  async saveMagazzino(fd) {
    const url = `${this.baseUrl}/creazione-magazzino`
    return await this.getPostByUrl(url, fd)
  }
  async saveDataNewElement(type_element, fd) {
    const url = `${this.baseUrl}/creazione-${type_element}`
    return await this.getPostByUrl(url, fd)
  }
  async getDepositi() {
    const url = `${this.baseUrl}/depositi`
    return await this.getGetByUrl(url)
  }
  async saveDeposito(fd) {
    const url = `${this.baseUrl}/save-deposito`
    return await this.getPostByUrl(url, fd)
  }
  async deleteDeposito(id) {
    const url = `${this.baseUrl}/delete-deposito/${id}`
    return await axios.delete(url)
  }
  async getGiacenzeDeposito(id) {
    const url = `${this.baseUrl}/giacenze-deposito/${id}`
    return await this.getGetByUrl(url)
  }
  async allineaGiacenza(fd) {
    const url = `${this.baseUrl}/allinea-giacenza`
    return await this.getPostByUrl(url, fd)
  }
  async sendDataNewPersonale(fd) {
    const url = `${this.baseUrl}/creazione-personale`
    return await this.getPostByUrl(url, fd)
  }
  async setCompleteSession(fd) {
    const url = `${this.baseUrl}/completa-sessione`
    return await this.getPostByUrl(url, fd)
  }
  async setStripeUsed(fd, id) {
    const url = `${this.baseUrl}/setStripeUsed/${id}`
    return await this.getPostByUrl(url, fd)
  }
  async setBancaUsed(fd, id) {
    const url = `${this.baseUrl}/setBancaUsed/${id}`
    return await this.getPostByUrl(url, fd)
  }
  async saveConvocazione(fd) {
    const url = `${this.baseUrl}/saveConvocazione`
    return await this.getPostByUrl(url, fd)
  }

  async sendDataNewCorso(fd) {
    let item = [];
    const url = `${this.baseUrl}/creazione-corso`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async removeRequiredDoc(data) {
    const url = `${this.baseUrl}/course/remove-required-doc`
    return await this.getPostByUrl(url, data)
  }

  async addRequiredDoc(data) {
    const url = `${this.baseUrl}/course/add-required-doc`
    return await this.getPostByUrl(url, data)
  }

  async sendDataNewIscrizione(fd) {
    let item = [];
    const url = `${this.baseUrl}/creazione-iscrizione`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async updateVisibileNewsInApp(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/set-news/${id}/visibile`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async updateVisibileSponsor(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/set-sponsor/${id}/visibile`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async updateVisibileModulistica(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/modulistica/${id}/visibile`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async updateVisibile(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/set-statica/${id}/visibile`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async updateValueIntro(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/update-intro/${id}`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async updateVisibileIntro(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/set-intro/${id}/visibile`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async updateApprovaStripe(fd, id) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/approvaStripe/${id}`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async updateDeleteRichiestaPulmino(fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/deletePulmino`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async updateCancelApprovaRichiestaPulmino(fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/notApprovaPulmino`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async updateApprovaRichiestaPulmino(fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/approvaPulmino`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async updateApprovaRichiesta(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/set-approved-richiesta/${id}`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async updateApprovaRichiestaApp(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/set-approved-richiesta-utente/${id}`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }


  async updateApprovaDocumento(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/set-approved-documento/${id}`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }



  async deleteModulistica(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/modulistica/${id}/delete`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }


  async deleteValueIntro(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/del-intro/${id}`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async deleteValueStatica(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/del-statica/${id}`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async deleteValueNewsInApp(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/del-newsInApp/${id}`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  } async deleteValueSponsor(id, fd) {
    let item = [];
    // Implementa la logica per chiamare l'API e aggiornare la visibilità
    const url = `${this.baseUrl}/del-sponsor/${id}`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async sendStatica(fd) {
    let item = [];
    const url = `${this.baseUrl}/add-statica`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async sendNews(fd) {
    let item = [];
    const url = `${this.baseUrl}/add-news`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async sendSponsor(fd) {
    let item = [];
    const url = `${this.baseUrl}/add-sponsor`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }
  async checkCampi(fd) {
    let item = [];
    const url = `${this.baseUrl}/verifica-disponibilita`
    try {
      const res = await axios.post(url, fd)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      item
    }
  }

  async getChats(type = null) {
    let url = `${this.baseUrl}/chat/chats`
    if (type) {
      url += `?type=${type}`
    }
    return await this.getGetByUrl(url)
  }

  async getChatMessages(chatId) {
    const url = `${this.baseUrl}/chat/${chatId}/messages`
    return await this.getGetByUrl(url)
  }

  async sendChatMessage(type, message, categoryId = null, chatId = null) {
    const url = `${this.baseUrl}/chat/sendAdmin`
    const fd = new FormData()
    fd.append('type', type)
    fd.append('message', message)
    if (categoryId) fd.append('category_id', categoryId)
    if (chatId) fd.append('chat_id', chatId)

    return await this.getPostByUrl(url, fd)
  }

  // Staff Reimbursements
  async getConvocationReimbursements(convocationId) {
    const url = `${this.baseUrl}/get-convocation-reimbursements/${convocationId}`
    return await this.getGetByUrl(url)
  }

  async saveConvocationReimbursements(convocationId, reimbursements) {
    const url = `${this.baseUrl}/save-convocation-reimbursements`
    const fd = new FormData()
    fd.append('convocation_id', convocationId)
    fd.append('reimbursements', JSON.stringify(reimbursements))
    return await this.getPostByUrl(url, fd)
  }

  async deleteConvocationReimbursement(id) {
    const url = `${this.baseUrl}/delete-convocation-reimbursement/${id}`
    try {
      const res = await axios.delete(url)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      return null
    }
  }

  async getStaffReimbursements(staffId) {
    const url = `${this.baseUrl}/get-staff-reimbursements/${staffId}`
    return await this.getGetByUrl(url)
  }

  async getAllStaff() {
    const url = `${this.baseUrl}/all-staff`
    return await this.getGetByUrl(url)
  }

  async generatePaymentLink(idTorneo, importo) {
    const url = `${this.baseUrl}/generatePaymentLink`
    const fd = new FormData()
    fd.append('id_torneo', idTorneo)
    fd.append('importo', importo)
    return await this.getPostByUrl(url, fd)
  }

  async sendConvocationEmails(idTorneo) {
    const url = `${this.baseUrl}/sendConvocationEmails`
    const fd = new FormData()
    fd.append('id_torneo', idTorneo)
    return await this.getPostByUrl(url, fd)
  }

  async sendPaymentReminderEmails(idTorneo) {
    const url = `${this.baseUrl}/sendPaymentReminderEmails`
    const fd = new FormData()
    fd.append('id_torneo', idTorneo)
    return await this.getPostByUrl(url, fd)
  }

  async getUnvalidatedDocumentsCount() {
    const url = `${this.baseUrl}/reports/unvalidated-docs-count`
    try {
      const res = await axios.get(url)
      return res.data
    } catch (e) {
      console.error('Error fetching unvalidated docs count:', e);
      return { count: 0 }
    }
  }

  async getRichiesteProvaCount() {
    const url = `${this.baseUrl}/get-richiesteProvaCount`
    try {
      const res = await axios.get(url)
      return res.data
    } catch (e) {
      console.error('Error fetching trial requests count:', e);
      return { count: 0 }
    }
  }


  async sendMissingDocsNotification(idTypeCorso) {
    const url = `${this.baseUrl}/send-missing-docs-notification`
    const fd = new FormData()
    fd.append('id_type_corso', idTypeCorso)
    return await this.getPostByUrl(url, fd)
  }

  async getMissingDocsAthletes(idTypeCorso) {
    const url = `${this.baseUrl}/get-missing-docs-athletes/${idTypeCorso}`
    return await this.getGetByUrl(url)
  }

  async sendMessaggeGruppoSelezionatiBulk(title, body, userIds) {
    const url = `${this.baseUrl}/sendMessaggeGruppoSelezionati`
    return await axios.post(url, {
      title: title,
      body: body,
      user_ids: userIds
    })
  }

  async getCorsiByType(idTypeCorso) {
    const url = `${this.baseUrl}/get-corsi-by-type/${idTypeCorso}`
    return await this.getGetByUrl(url)
  }

  async getMissingDocsAthletesByCourse(idCorso) {
    const url = `${this.baseUrl}/get-missing-docs-athletes-by-course/${idCorso}`
    return await this.getGetByUrl(url)
  }

  async sendMissingDocsNotificationByCourse(idCorso) {
    const url = `${this.baseUrl}/send-missing-docs-notification-by-course`
    const fd = new FormData()
    fd.append('id_corso', idCorso)
    return await this.getPostByUrl(url, fd)
  }

  async splitPayment(data) {
    const url = `${this.baseUrl}/split-payment`
    try {
      const res = await axios.post(url, data)
      return { item: res.data }
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getGiacenzeProdotto(id) {
    const url = `${this.baseUrl}/prodotto/${id}/giacenze`
    return await this.getGetByUrl(url)
  }

  async getVenditeMensiliProdotto(id) {
    const url = `${this.baseUrl}/prodotto/${id}/vendite-mensili`
    return await this.getGetByUrl(url)
  }

  async getVenditePerTipoCorso(id) {
    const url = `${this.baseUrl}/prodotto/${id}/vendite-tipo-corso`
    return await this.getGetByUrl(url)
  }

  async getSalesForecast(id) {
    const url = `${this.baseUrl}/prodotto/${id}/sales-forecast`
    return await this.getGetByUrl(url)
  }

  getExportSalesStatsCSVUrl(id) {
    return `${this.baseUrl}/prodotto/${id}/export-stats-csv`
  }

  async exportSalesStatsCSV(id) {
    const url = this.getExportSalesStatsCSVUrl(id)
    try {
      const res = await axios.get(url, { responseType: 'blob' })
      this.filemanager.download(res)
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    }
  }

  async spostaIscrittiCorso(idCorsoOld, idCorsoNew) {
    const url = `${this.baseUrl}/sposta-iscritti-corso`
    const fd = new FormData()
    fd.append('id_corso_old', idCorsoOld)
    fd.append('id_corso_new', idCorsoNew)
    return await this.getPostByUrl(url, fd)
  }

  // --- BANNERS APP ---
  async getBannersApp() {
    const url = `${this.baseUrl}/get-banners`
    return await this.getGetByUrl(url)
  }
  
  async addBanner(fd) {
    const url = `${this.baseUrl}/add-banner`
    return await this.getPostByUrl(url, fd)
  }

  async editBanner(fd) {
    const url = `${this.baseUrl}/update-banner`
    return await this.getPostByUrl(url, fd)
  }

  async delBanner(id) {
    const url = `${this.baseUrl}/del-banner/${id}`
    return await this.getPostByUrl(url, {})
  }

  async setBannerVisibile(id, data) {
    const url = `${this.baseUrl}/set-banner/${id}/visibile`
    return await this.getPostByUrl(url, data)
  }

}
